import React from 'react';
import {usePage} from "@inertiajs/inertia-react";

const hasPermission = ({ permissions, scopes }) => {
  const scopesMap = {};
  scopes.forEach((scope) => {
    scopesMap[scope] = true;
  });

  return permissions.some((permission) => scopesMap[permission]);
};

const PermissionsGate = ({children, scopes = []}) => {
  const {auth: {user}} = usePage().props;
  const permissions = user?.accesses ? user.accesses : [];
  const permissionGranted = hasPermission({ permissions, scopes });

  if (!permissionGranted) return <></>

  return <>{children}</>;
};

export default PermissionsGate;
